import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from './config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});
  // Automatic retry for cold starts
  api.interceptors.response.use(
    response => response,
    async error => {
      const config = error.config;

      if (!config || !config.retry) {
        config.retry = 3; // retry attempts
        config.retryDelay = 2000; // 2 seconds
      }

      if (config.retry > 0) {
        config.retry -= 1;

        await new Promise(resolve =>
          setTimeout(resolve, config.retryDelay)
        );

        return api(config);
      }

      return Promise.reject(error);
    }
  );

// API functions
export const portfolioApi = {
  // Get personal information
  getPersonalInfo: async () => {
    const response = await api.get(API_ENDPOINTS.PERSONAL_INFO);
    return response.data;
  },

  // Get education details
  getEducation: async () => {
    const response = await api.get(API_ENDPOINTS.EDUCATION);
    return response.data;
  },

  // Get research projects (with optional status filter)
  getResearchProjects: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get(API_ENDPOINTS.RESEARCH_PROJECTS, { params });
    return response.data;
  },

  // Get single research project by ID
  getResearchProject: async (id) => {
    const response = await api.get(`${API_ENDPOINTS.RESEARCH_PROJECTS}/${id}`);
    return response.data;
  },

  // Get publications (with optional status filter)
  getPublications: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get(API_ENDPOINTS.PUBLICATIONS, { params });
    return response.data;
  },

  // Get experience
  getExperience: async () => {
    const response = await api.get(API_ENDPOINTS.EXPERIENCE);
    return response.data;
  },

  // Get certifications
  getCertifications: async () => {
    const response = await api.get(API_ENDPOINTS.CERTIFICATIONS);
    return response.data;
  },

  // Get skills
  getSkills: async () => {
    const response = await api.get(API_ENDPOINTS.SKILLS);
    return response.data;
  },

  // Get achievements
  getAchievements: async () => {
    const response = await api.get(API_ENDPOINTS.ACHIEVEMENTS);
    return response.data;
  },

  // Get testimonials
  getTestimonials: async () => {
    const response = await api.get(API_ENDPOINTS.TESTIMONIALS);
    return response.data;
  },

  // Get blog posts
  getBlogPosts: async () => {
    const response = await api.get(API_ENDPOINTS.BLOG_POSTS);
    return response.data;
  }
};

export default portfolioApi;
